import { AlertCircle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

export default function NoDataComponent({ message =null, onRetry =null}) {
  // if (!message) return null;

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-destructive flex items-center gap-2 text-center justify-center">
            <AlertCircle className="w-5 h-5" />
            <span>NO DATA Found</span>
          </CardTitle>
        </CardHeader>

{
  message &&<CardContent>
          <p className="text-sm text-muted-foreground">{message}</p>
        </CardContent>
}
        
      </Card>
    </div>
  );
}
